import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular'
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DataService {

  api = environment.apiUrl;
  
  headers:any = new HttpHeaders();
  options:any;

  constructor(private http: HttpClient) { 
    //this.headers.append('Content-Type','application/json');
    //this.options = { headers: this.headers };
  }

  getAccessioningList() {
    return this.http.get<any>(this.api + 'instrudex/accessioninglist')
    .toPromise()
    .then(res => <any[]>res)
    .then(data => { return data; });
  }
  getEchoList() {
    return this.http.get<any>(this.api + 'instrudex/echolist')
    .toPromise()
    .then(res => <any[]>res)
    .then(data => { return data; });
  }
  getIsolationList() {
    return this.http.get<any>(this.api + 'instrudex/isolationlist')
    .toPromise()
    .then(res => <any[]>res)
    .then(data => { return data; });
  }
  getLysingList() {
    return this.http.get<any>(this.api + 'instrudex/lysinglist')
    .toPromise()
    .then(res => <any[]>res)
    .then(data => { return data; });
  }
  getTPrepList() {
    return this.http.get<any>(this.api + 'instrudex/tpreplist')
    .toPromise()
    .then(res => <any[]>res)
    .then(data => { return data; });
  }

  getConfig() {
    return this.http.get<any>(this.api + 'instrudex/config')
    .toPromise()
    .then(res => <any[]>res)
    .then(data => { return data; });
  }

  updateConfig(config:any) {
    return this.http.post<any>(this.api + "instrudex/UpdateConfig", JSON.stringify(config))
    .toPromise()
    .then(response => {
        return response as any;
    });
  }

  getEventsByBarcode(barcode: string) {
    return this.http.get<any>(this.api + 'instrudex/tracker?barcode=' + barcode)
    .toPromise()
    .then(res => <any[]>res)
    .then(data => { return data; });
  }

  getInstrumentsByName(name: string) {
    return this.http.get<any>(this.api + 'instrudex/Instrument?instrumentName=' + name)
    .toPromise()
    .then(res => <any[]>res)
    .then(data => { return data; });
  }

  getIsoGraph() {
    return this.http.get<any>(this.api + 'instrudex/IsoGraphs')
    .toPromise()
    .then(res => <any[]>res)
    .then(data => { return data; });
  }

  getABIGraphs(abiName: string) {
    return this.http.get<any>(this.api + 'instrudex/ABIGraphs?abiName=' + abiName)
    .toPromise()
    .then(res => <any[]>res)
    .then(data => { return data; });
  }

  getEchoGraphs() {
    return this.http.get<any>(this.api + 'instrudex/EchoGraphs')
    .toPromise()
    .then(res => <any[]>res)
    .then(data => { return data; });
  }

  getABINames() {
    return this.http.get<any>(this.api + 'instrudex/ABINames')
    .toPromise()
    .then(res => <any[]>res)
    .then(data => { return data; });
  }

  updateNotificationKeys(notifKeys:any) {
    return this.http.post<any>(this.api + "notification/UpdateNotificationKeys", JSON.stringify(notifKeys))
    .toPromise()
    .then(response => {
        return response as any;
    });
  }
  
  isSubValid(){
    return this.http.get<any>(this.api + "notification/IsSubValid")
    .toPromise()
    .then(response => {
        return response as any;
    });
  }
}
